import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative bg-navy-900 border-2 border-gold-500/40 rounded-3xl p-8 sm:p-12 text-center box-glow overflow-hidden" data-id="element-74">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-gold-500/10 via-transparent to-transparent pointer-events-none" data-id="element-75" />

          <div className="relative z-10" data-id="element-76">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-navy-950 border border-gold-500/30 mb-8 shadow-lg" data-id="element-77">
              <ShieldCheck className="w-10 h-10 text-gold-400" data-id="element-78" />
            </div>

            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-79">
              Garantía Total: Riesgo Cero
            </h2>

            <div className="flex items-center justify-center space-x-3 mb-6" data-id="element-80">
              <span className="text-slate-500 line-through text-lg" data-id="element-81">
                $17.99
              </span>
              <span className="text-3xl font-black text-gold-400" data-id="element-82">
                $6.36 USD
              </span>
            </div>

            <p className="text-lg text-slate-300 leading-relaxed mb-6 font-light" data-id="element-83">
              Esta guía está construida sobre estrategias probadas y reales.
              Pero si por cualquier razón no es lo que esperabas, tienes nuestra
              garantía completa. Sin preguntas. Sin complicaciones.
            </p>

            <p className="text-xl font-serif text-gold-400 font-medium italic" data-id="element-84">
              Porque los sistemas que funcionan no necesitan forzarte a quedarte
              — te convencen solos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}